export const SAMPLING_TYPE = {
  AUTO: 'AUTO',
  MANUAL: 'MANUAL',
};

export const NUMBER_TYPE = {
  RATE: 'RATE',
  STATIC: 'STATIC',
};

export const PAGE_TARGETING_ENABLED_TYPE = {
  RECORD_ALL: 'RECORD_ALL',
  RECORD_SPECIFIC: 'RECORD_SPECIFIC',
  RECORD_BY_JS: 'RECORD_BY_JS',
};
